import { dateFormat2Day as dateFormatToDay, dayFormat2Date as dayFormatToDate, sizeOf } from 'logan-web/build/lib/utils';
import GlobalConfig from '../global_configs';
import Cookie from './cookie';
import Constants from '../constants';
import GlobalConfigs from '../global_configs';
import Owl from './owl';
var ONE_DAY_TIME_SPAN = 24 * 60 * 60 * 1000;
/**
 * @returns
 * -1: a 小于 b
 * 1: a 大于 b
 * 0: a 等于 b
 * @throws Error 当version非法时
 * @param aVersion
 * @param bVersion
 */
export function versionCompare(aVersion, bVersion) {
    function singleCompare(a, b) {
        var aNum = parseInt(a);
        var bNum = parseInt(b);
        if (isNaN(aNum) || isNaN(bNum)) {
            throw new Error;
        }
        else {
            if (aNum < bNum) {
                return -1;
            }
            else if (aNum > bNum) {
                return 1;
            }
            else if (a !== b) {
                var aPre = a.split('-')[1];
                var bPre = b.split('-')[1];
                if (aPre === undefined && bPre !== undefined) {
                    return 1;
                }
                else if (aPre !== undefined && bPre === undefined) {
                    return -1;
                }
                else {
                    return aPre > bPre ? 1 : -1;
                }
            }
            else {
                return 0;
            }
        }
    }
    if (typeof aVersion === 'string' && typeof bVersion === 'string') {
        var aVersionParsed = aVersion.split('.');
        var bVersionParsed = bVersion.split('.');
        var cursor = 0;
        while (cursor < aVersionParsed.length) {
            var singleCompareResult = singleCompare(aVersionParsed[cursor], bVersionParsed[cursor]);
            if (singleCompareResult === 0) {
                if (cursor === aVersionParsed.length - 1 || cursor === bVersionParsed.length - 1) {
                    // 如果已遍历了a或者b
                    if (cursor < bVersionParsed.length - 1) {
                        return -1; // b的位数更多，则版本更大
                    }
                    else if (cursor < aVersionParsed.length - 1) {
                        return 1; // a的位数更多，则版本更大
                    }
                    else {
                        return 0;
                    }
                }
                else {
                    cursor++;
                }
            }
            else {
                return singleCompareResult;
            }
        }
        throw new Error;
    }
    else {
        throw new Error;
    }
}
export function generateRandomBytes(byteLength) {
    var result = '';
    while (result.length < byteLength) {
        result += Math.random()
            .toString(36)
            .substr(2, 1);
    }
    return result;
}
export function getDawnTime(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}
export function getOffsetDayTime(date, offsetDayNum) {
    return getDawnTime(new Date(date.getTime() + offsetDayNum * ONE_DAY_TIME_SPAN));
}
export var dateFormat2Day = dateFormatToDay;
export var dayFormat2Date = dayFormatToDate;
export function getIntervalDays(fromDayString, toDayString) {
    var startDate = dayFormat2Date(fromDayString);
    var endDate = dayFormat2Date(toDayString);
    var days = [];
    for (var logTime = +startDate; logTime <= +endDate; logTime += ONE_DAY_TIME_SPAN) {
        var logDay = dateFormat2Day(new Date(logTime));
        days.push(logDay);
    }
    return days;
}
export var getStringSize = sizeOf;
export function consoleLoganIfSwitchIsOn(content) {
    if (GlobalConfig.get('consoleLogan')) {
        window.console && console.log(content);
    }
}
var _parseUnionIdFromGlobalCustomReport = function () {
    var globalCustomReport = GlobalConfigs.get('customReport');
    if (globalCustomReport && globalCustomReport.unionId) {
        if (globalCustomReport.biz) {
            return globalCustomReport.biz + "|" + globalCustomReport.unionId;
        }
        else {
            return globalCustomReport.unionId;
        }
    }
    else {
        return undefined;
    }
};
var _getUnionIdFromLX = function () {
    return Cookie.get(Constants.COOKIENAME_LX_CUID);
};
export function getLoganUnionId() {
    return _parseUnionIdFromGlobalCustomReport() || Owl.getCurrentOwlUnionId() || _getUnionIdFromLX() || "" + location.origin + location.pathname;
}
/**
 * 固定间隔 降频调用异步函数
 */
var InvokeByInterval = /** @class */ (function () {
    function InvokeByInterval(interval) {
        this.interval = 1000;
        this.current = Promise.resolve();
        this.interval = interval !== null && interval !== void 0 ? interval : this.interval;
    }
    InvokeByInterval.prototype.call = function (fn) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            _this.current = _this.current.finally(function () {
                fn.apply(void 0, args).then(resolve).catch(reject);
                return new Promise(function (r) {
                    setTimeout(r, _this.interval);
                });
            });
        });
    };
    return InvokeByInterval;
}());
export { InvokeByInterval };
